import { render, staticRenderFns } from "./RolesEdit.vue?vue&type=template&id=fd09f652"
import script from "./RolesEdit.vue?vue&type=script&lang=js"
export * from "./RolesEdit.vue?vue&type=script&lang=js"
import style0 from "./RolesEdit.vue?vue&type=style&index=0&id=fd09f652&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports